import axios from 'axios';
export var API_BASE_URL = '';
/*
* Need to change while deploy on prod.
* export var API_BASE_URL = 'https://track.appspaces.ca';
*
* */

const headers = {
    'Content-Type': 'application/json',
}

export function getBrandInfo(alias, lang) {
    let url = API_BASE_URL + "/brand-info";
    const params = [];
    if (alias) params.push("alias=" + encodeURIComponent(alias));
    if (lang)  params.push("lang="  + encodeURIComponent(lang));
    if (params.length) url += "?" + params.join("&");
    return axios.get(url, { headers: headers });
}

export function track(shipId, trackingNo, locale) {
    var params = '?';
    if (shipId && shipId !== '') {
        params = params + 'shipId=' + shipId
    }
    if (trackingNo && trackingNo !== '') {
        params = params + ((shipId && shipId !== '') ? '&' : '') + 'tracking=' + trackingNo
    }
    if (locale && locale !== '') {
        params = params + '&locale=' + encodeURIComponent(locale)
    }
    return axios.post(API_BASE_URL + "/track" + params, {}, {headers: headers});
}